
import { computed, defineComponent } from "vue";
import { VRating as VuetifyRating } from "vuetify/lib";

export default defineComponent({
  components: { VuetifyRating },
  props: {
    color: {
      type: String,
      default: "warning-40",
    },
    backgroundColor: {
      type: String,
      default: "warning-40",
    },
    dense: {
      type: Boolean,
      default: true,
    },
    halfIncrements: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    roundValue: {
      type: Boolean,
      default: true,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const roundedValue = computed(() => {
      if (props.roundValue) {
        return Math.round(props.value * 2) / 2;
      }

      return props.value;
    });

    return { roundedValue };
  },
});
